import TimePicker, { TimePickerProps } from "@components/form/TimePicker";
import { Position } from "@hooks/useRelativeCoordsAndSize";
import { JustifyContent, UIColor } from "@lib/types/generic";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { Group, Showcase } from "./StyleGuide";

const TimePickers = () => {
  const sizes = [
    "extra-small",
    "small",
    "medium",
    "large",
    "extra-large",
  ] as TimePickerProps["size"][];

  const [value, setValue] = useState(dayjs());
  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [pickerColor, setPickercolor] = useState<UIColor>("purple");
  const [pickerTextColor, setPickerTextColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<TimePickerProps["variant"]>("contained");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [justifyContent, setJustifyContent] = useState<JustifyContent>("space-between");
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    position: "portal-absolute" as Position,
    value,
    onChange: ({ value }: { value: Dayjs }) => setValue(value),
    color,
    textColor,
    pickerColor,
    pickerTextColor,
    variant,
    disabled,
    isLoading,
    justifyContent,
    rounded,
  };

  return (
    <Showcase
      title="Time Pickers"
      className="time-pickers"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
        {
          color: pickerColor,
          label: "Picker Color",
          onChange: setPickercolor,
        },
        {
          color: pickerTextColor,
          label: "Picker Text Color",
          onChange: setPickerTextColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
        {
          value: justifyContent,
          optionsArray: ["space-between", "flex-start", "center", "flex-end"],
          label: "Justify",
          onChange: setJustifyContent,
        },
      ]}
      checkboxes={[
        {
          value: disabled,
          label: "Disabled",
          onChange: setDisabled,
        },
        {
          value: isLoading,
          label: "Is loading",
          onChange: setIsLoading,
        },
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <TimePicker size={size} {...props} />
          <TimePicker size={size} {...props} maxTime={dayjs().add(1, "hour")} />
          <TimePicker size={size} {...props} minTime={dayjs().subtract(1, "hour")} />
          <TimePicker
            size={size}
            {...props}
            maxTime={dayjs().add(1, "hour")}
            minTime={dayjs().subtract(1, "hour")}
          />
        </Group>
      ))}
    </Showcase>
  );
};

export default TimePickers;
